// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1_yLZ","containerItemsCenter":"Skeleton_containerItemsCenter__2MbR6"};